import React, { useEffect } from 'react'
import { useParams /*, useHistory */ } from 'react-router-dom'
import TopNavigation from '../../TopNavigation'
import { Container, Alert, Spinner } from 'reactstrap'
import { useSelector } from 'react-redux'
import { useFirebaseConnect, isLoaded } from 'react-redux-firebase'
import { Box, Button, Divider, Grid, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import withAppconfig from '../../AppContext'
import { connect } from 'react-redux'
import Poster from '../../components/Poster'
import PlusMinusButton from '../../components/Shop/PlusMinusButton'
import ExtraInputField from '../../components/ExtraInputField'
import moment from 'moment'
import 'moment/locale/fi' // Import Finnish locale for moment.js

const enhance = connect(({ globaltime: { gtime }, firebase: { auth } }) => ({
  gtime,
  auth,
}))

// Grid based component for adding event tickets to the cart and checkout
function EventTicketVariationSelector({
  variations,
  onUpdate,
  ticketVariantAmounts,
  isAuth,
  gtime,
  disabled,
}) {
  const { t } = useTranslation()

  const handleChange = (varid, amount) => {
    const newAmounts = { ...ticketVariantAmounts, [varid]: amount }
    onUpdate(newAmounts)
  }

  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      {variations.map((v) => {
        const earlyBirdPrice = v.earlybirdprice ? (v.earlybirdprice).toFixed(2).replace('.', ',') + ' € / kpl' : null
        const earlyBirdDeadline = v.earlybirddeadline ? moment(v.earlybirddeadline).format('D.M.YY') : null
        const maxAmount = (v.ticketsavailable || 0) - (v.quantity || 0)
          return (
            <React.Fragment key={v.id + '-fragment'}>
              <Grid item xs={5} key={v.id + '-name'}>
                <Typography variant='h6' component='span' style={{ marginRight: 10 }}>
                  {v.name}
                </Typography>
              </Grid>
              <Grid item xs={3} key={v.id + '-price'}>
                {earlyBirdPrice && earlyBirdDeadline && gtime.isBefore(moment(v.earlybirddeadline)) ? (
                  <Typography variant='body2' component='span' style={{ marginRight: 10 }}>
                    {/* <span style={{ textDecoration: 'line-through', color: '#888' }}>{(v.price / 100).toFixed(2).replace('.', ',')} €</span> {t('earlybird')} {earlyBirdPrice}  {earlyBirdDeadline} {t('until')} */}
                    <span style={{ fontWeight: 'bold' }}> { `${earlyBirdPrice} ${earlyBirdDeadline} ${t('until')}` }</span><br />
                    {t('after_that')} {(v.price / 100).toFixed(2).replace('.', ',')} € / kpl
                  </Typography>
                ) : (<Typography variant='body2' component='span' style={{ marginRight: 10 }}>
                    {`${(v.price / 100).toFixed(2).replace('.', ',')} € / kpl`}
                  </Typography>)}
                {!earlyBirdPrice && !earlyBirdDeadline ? (
                  <Typography variant='body2' component='span' style={{ marginRight: 10 }}>
                    {`${(v.price / 100).toFixed(2).replace('.', ',')} € / kpl`}
                  </Typography>
                ) : null}
              </Grid>
              <Grid item xs={4} key={`input-${v.id}`} style={{ textAlign: 'right' }}>
                {maxAmount <= 0 ? (
                  <Typography variant='body2' style={{ color: '#888' }}>
                    {v.soldOutText || 'Loppuunmyyty'}
                  </Typography>
                ) : (
                <PlusMinusButton
                  onChange={(amount) => handleChange(v.id, amount)}
                  loading={false}
                  max={maxAmount}
                  disabled={!isAuth || disabled}
                  />
                )}
              </Grid>
              <Grid item xs={12} key={`divider-${v.id}`}>
                <Typography variant='caption' style={{ color: '#888' }}>
                  {v.description || 'Ei lisätietoja'}
                </Typography>
                <Divider style={{ margin: '10px 0' }} />
              </Grid>
            </React.Fragment>
          )
      })}
    </Grid>
  )
}

function checkTicket(eventTicket, gtime) {
  if (eventTicket && eventTicket.variations && eventTicket.variations.length > 0) {
    eventTicket.variations = eventTicket.variations.filter((v) => {
      if (v.earlybirddeadline) {
        // just remove earlybindprice and earlybirddeadline if deadline has passed
        const earlybirddeadline = moment(v.earlybirddeadline)
        if (gtime.isAfter(earlybirddeadline)) {
          delete v.earlybirdprice
          delete v.earlybirddeadline
        }
      }
      return true
    })
  }
  if (eventTicket && eventTicket.ticketsalesstart && eventTicket.ticketsalesend) {
    eventTicket.isActive = gtime.isBetween(moment(eventTicket.ticketsalesstart), moment(eventTicket.ticketsalesend), null, '[]')
    return eventTicket
  }
  return eventTicket
}

function EventTicketScreen({ appconfig, gtime, auth }) {
  const params = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const [ticketVariantAmounts, setTicketVariantAmounts] = React.useState({})
  const [extraInfoValues, setExtraInfoValues] = React.useState({})
  const [extrasToShow, setExtrasToShow] = React.useState([])
  const [okToCheckout, setOkToCheckout] = React.useState(false)
  // const [profileIsValid, setProfileIsValid] = React.useState(false)
  // own subscription so deep links / post-login returns to /shop/w/:id work without
  // passing through the ticket list first
  useFirebaseConnect([
    {
      path: 'shop/' + appconfig.accountkey + '/eventtickets',
      storeAs: 'shopeventtickets',
    },
  ])
  const ticketsLoaded = useSelector((state) => isLoaded(state.firebase.data.shopeventtickets))
  // a subscription error never marks the path loaded, so bail out of the spinner eventually
  const [loadTimedOut, setLoadTimedOut] = React.useState(false)
  useEffect(() => {
    if (ticketsLoaded) return undefined
    const timer = setTimeout(() => setLoadTimedOut(true), 10000)
    return () => clearTimeout(timer)
  }, [ticketsLoaded])
  const eventTicket = useSelector((state) => {
    const _eventTicket =
      state.firebase.data.shopeventtickets &&
      state.firebase.data.shopeventtickets[params.id]
    return checkTicket(_eventTicket, gtime)
  })

  const isAuth = auth.isLoaded && !auth.isEmpty && !auth.isAnonymous
  console.log('EventTicketScreen auth', auth, isAuth)

  const { poster, variations } = eventTicket || {}
  if (
    eventTicket &&
    Object.keys(ticketVariantAmounts).length === 0 &&
    variations &&
    variations.length > 0
  ) {
    const initialAmounts = {}
    variations.forEach((v) => {
      initialAmounts[v.id] = 0
    })
    setTicketVariantAmounts(initialAmounts)
  }


  useEffect(() => {
    // check if there is selected tickets which require extra info and if so, make sure that fields which are required are filled in before allowing to proceed to checkout
    const requiredExtras = extrasToShow.filter((extra) => extra.required)
    const allRequiredExtrasFilled = requiredExtras.every((extra) => extraInfoValues[extra.id])

    const allTicketVariantsHaveZeroAmount = !Object.keys(ticketVariantAmounts).some(
                  (key) => ticketVariantAmounts[key] > 0
                )

    // you can use allRequiredExtrasFilled to enable/disable the checkout button or show a warning message
    setOkToCheckout(allRequiredExtrasFilled && !allTicketVariantsHaveZeroAmount)

  }, [extrasToShow, extraInfoValues, ticketVariantAmounts])

  const handleExtraInfoChange = (extraId, value) => {
    setExtraInfoValues((prev) => ({
      ...prev,
      [extraId]: value,
    }))
  }

  if (!ticketsLoaded && !eventTicket && !loadTimedOut) {
    return (
      <div className='full-page-background'>
        <TopNavigation />
        <Container className='front' style={{ paddingTop: 30, textAlign: 'center' }}>
          <Spinner size='sm' color='secondary' />
        </Container>
      </div>
    )
  }
  if (!eventTicket) {
    // redirect to /shop/tickets if event ticket is not found
    history.push(appconfig.pathPrefix + '/shop/tickets')
    return null
  }

  const updateTicketVariantAmounts = (newAmounts) => {
    // check if newAmounts has id which requires extra info and if so, add it to extrasToShow
    const extrasToShow = []
    Object.keys(newAmounts).forEach((varid) => {
      const amount = newAmounts[varid]
      if (amount > 0) {
        const variation = variations.find((v) => v.id === varid)
        if (variation && variation.extrainfo && variation.extrainfo.length > 0) {
          variation.extrainfo.forEach((extraid) => { //extrainfo is an array of extrainfo ids
            const extra = eventTicket.extrainfo.find((e) => e.id === extraid)
            if (extra) {
              extrasToShow.push(extra)
            }
          })
        }
      }
    })
    setExtrasToShow(extrasToShow)
    setTicketVariantAmounts(newAmounts)
  }

  // let variationsSelector = null
  // if (eventTicket.variations) {
  //   if (eventTicket.variations.length > 1) {
  //     variationsSelector = eventTicket.variations.map((v) => {
  //       return (
  //         <Chip
  //           clickable
  //           label={v.name}
  //           key={'varid-' + v.varid}
  //           color={selectedVariant?.varid === v.varid ? 'primary' : 'default'}
  //           variant={selectedVariant?.varid === v.varid ? 'outlined' : 'default'}
  //           onClick={() => setSelectedVariant(v)}
  //           style={{ margin: 5 }}
  //         />
  //       )
  //     })
  //   } else {
  //     variationsSelector = <Typography variant='h5'>{eventTicket.variations[0].name}</Typography>
  //     if (selectedVariant === null) {
  //       setSelectedVariant(eventTicket.variations[0])
  //     }
  //   }
  // }

  const goToPay = (ticket) => {
    ticket.type = 'eventticket'
    extrasToShow.forEach((extra) => {
      ticket.extraInfo = ticket.extraInfo || {}
      ticket.extraInfo[extra.id] = extraInfoValues[extra.id] || ''
    })
    dispatch({
      type: 'UPDATE_PAYABLE_EVENTTICKET',
      payload: ticket,
    })
    history.push(appconfig.pathPrefix + '/tickets/checkout')
  }


  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
        {/* {!isAuth ? (<Alert color='warning'>{t('login_to_buy_eventtickets')}</Alert>) : null} */}
          <Grid container spacing={3} alignItems='flex-start'>
          <Grid
            item
            xs={12}
            md={6}
            style={{ textAlign: 'center', paddingTop: 40 }}
          >
            <Poster
              data={poster}
              preferredSize={1080}
              alt={eventTicket.displayName}
              defaultBg={appconfig.logos}
              style={{ width: '100%' }}
            />
            <Typography variant='body1' style={{ marginTop: 20, textAlign: 'left' }}>
              <span
                dangerouslySetInnerHTML={{ __html: eventTicket.description }}
              />
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ paddingTop: '5em', paddingRight: 20 }}
          >
            <Typography variant='h4'>
              {eventTicket.displayName.toUpperCase()}
            </Typography>
            {!eventTicket.isActive && (
              <Typography variant='caption' style={{ color: 'red', marginTop: 10 }}>
                {t('ticket_sale_starts')} {moment(eventTicket.ticketsalesstart).format('D.M.YY H:mm')}
              </Typography>
            )}
            <Typography variant='subtitle1' style={{ marginTop: 10 }}>{moment(eventTicket.start).format('D.M.YY H:mm')}</Typography>
            { eventTicket.address && (
              <Typography variant='subtitle1' style={{ marginTop: 10 }}>
                {eventTicket.address}
              </Typography>
            )}
            <Divider />
            {/* {variationsSelector} */}
            {/* <div>
              <Typography variant='h6'>
                {selectedVariant ? (selectedVariant.price / 100).toFixed(2).replace('.', ',') + ' €' : null}
              </Typography>
              <Typography variant='caption'>
                {selectedVariant ? t('vat') + ' ' + eventTicket.vat + ' %' : null}
              </Typography>
            </div> */}
            
            <EventTicketVariationSelector
              variations={variations}
              onUpdate={updateTicketVariantAmounts}
              ticketVariantAmounts={ticketVariantAmounts}
              isAuth={isAuth}
              gtime={gtime}
              disabled={!eventTicket.isActive}
            />
            {extrasToShow.length > 0 && (
              <Box style={{ marginTop: 20 }}>
                {extrasToShow.map((extra) => (
                <ExtraInputField
                  label={extra.title}
                  key={extra.id}
                  id={extra.id}
                  required={extra.required}
                    value={extraInfoValues[extra.id] || ''}
                    onChange={(value) => handleExtraInfoChange(extra.id, value)}
                />
                ))}
              </Box>
            )}
            <Box style={{ marginTop: 20 }}>
              <Typography variant='subtitle1'>
                {t('total_price') + ': '}
                <span style={{ fontWeight: 'bold' }}>
                  {Object.keys(ticketVariantAmounts).reduce((total, key) => {
                    const amount = ticketVariantAmounts[key] || 0
                    const variation = variations.find((v) => v.id === key)
                    if (!variation) return total
                    const price = variation.earlybirdprice ? variation.earlybirdprice * 100 : variation.price
                    return total + (amount * price) / 100
                  }, 0)
                    .toFixed(2)
                    .replace('.', ',') + ' €'}
                </span>
              </Typography>
              <Typography variant='caption' style={{ color: '#888' }}>
                {t('vat') + ' ' + eventTicket.vat + ' %'}
              </Typography>
            </Box>
            <Button
              variant='contained'
              color='primary'
              disabled={!okToCheckout || !eventTicket.isActive}
              style={{ marginTop: 10, marginBottom: 10 }}
              onClick={() => goToPay({ ...eventTicket, ticketVariantAmounts })}
            >
              {t('buy')}
            </Button>
            {!eventTicket.isActive && (
              <Typography variant='caption' style={{ color: 'red', marginTop: 10, marginLeft: 15 }}>
                {t('ticket_sale_starts')} {moment(eventTicket.ticketsalesstart).format('D.M.YY H:mm')}
              </Typography>
            )}
            {!isAuth ? (<Alert color='warning'>{t('login_to_buy_eventtickets')}</Alert>) : null}

            {/* <Divider />
            <Typography variant='body1'>
              <span
                dangerouslySetInnerHTML={{ __html: eventTicket.description }}
              />
            </Typography> */}
          </Grid>
        </Grid>
        {/* <pre style={{ marginTop: 20, fontSize: 12 }}>
          {JSON.stringify(eventTicket, null, 2)}
        </pre>
        <pre>
          {eventTicket && eventTicket.ticketsalesstart && eventTicket.ticketsalesend ? (
            <Typography variant='caption' style={{ color: '#888' }}>
              {t('ticketsales')} {moment(eventTicket.ticketsalesstart).format('D.M.YY H:mm')} - {moment(eventTicket.ticketsalesend).format('D.M.YY H:mm')}
            </Typography>
          ) : null}
        </pre> */}
      </Container>
    </div>
  )
}

export default withAppconfig(enhance(EventTicketScreen))
